import { render } from "./SetPassword.vue?vue&type=template&id=6afa1217&scoped=true"
import script from "./SetPassword.vue?vue&type=script&lang=js"
export * from "./SetPassword.vue?vue&type=script&lang=js"

import "./SetPassword.vue?vue&type=style&index=0&id=6afa1217&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afa1217"]])

export default __exports__